// extracted by mini-css-extract-plugin
export default {"text_editor":"texteditor_text_editor__SopmX","lable":"texteditor_lable__OLyZg","wrapper":"texteditor_wrapper__-e0Xs","editor":"texteditor_editor__Lz5o9"};